import form_style_2_init from './form_styles/form_style_2';
import Dropdown from 'classes/Dropdown';

const dropdown_open_animation = 'fade-in-bottom-short 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both';

export default function init_forms(){
    gravityforms_init();
    raw_select_styling();
}

function gravityforms_init(){

    if( !document.querySelector('.gform_wrapper') ) return;

    if( typeof jQuery === 'undefined' ) return;

    jQuery(document).on('gform_post_render', function(event, form_id, current_page){
        const form = document.getElementById('gform_'+ form_id);
        if( !form ) return;
        dropdown_children_init(form);
        form_style_2_init(form);
    });
}

function dropdown_children_init(container){
    container.querySelectorAll('select').forEach(dropdown=>{
        new Dropdown(dropdown, {
            animation_open: dropdown_open_animation,
            // trigger gravityforms conditions
            on_select: ()=>{
                jQuery(dropdown).trigger('change');
            }, 
        });
    })
}

function raw_select_styling(){
    document.querySelectorAll('.select_style').forEach(dropdown=>{
        new Dropdown(dropdown, {
            animation_open: dropdown_open_animation,
        });
    })
}